var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerOrangeLightLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 99,
    viewBox: "0 0 178 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.332 59.162C72.667 66.208 79.485 90.626 109.782 89.156L109.375 88.321C109.375 88.321 103.746 58.877 80.381 56.776C86.99 54.885 92.909 52.774 98.252 50.655C100.524 58.739 109.428 80.521 137.965 77.288L137.49 76.479C137.49 76.479 130.274 48.033 107.673 46.643C112.258 44.598 115.973 42.581 119.079 40.879C131.542 44.282 167.82 50.074 178.464 6.269L177.066 6.259C177.066 6.259 121.397 -10.374 115.071 37.242C111.525 39.154 107.109 41.361 101.919 43.618C107.917 36.742 116.907 20.82 98.765 0L98.351 0.729996C98.351 0.729996 73.603 23.524 96.365 45.936C89.915 48.485 83.335 50.691 76.653 52.544C83.062 45.577 91.414 30.829 75.28 10.055L74.831 10.756C74.831 10.756 49.233 31.233 69.128 54.474C62.052 56.129 54.889 57.39 47.674 58.252C54.898 52.048 64.522 38.58 50.862 16.619L50.324 17.259C50.324 17.259 22.6 34.24 39.329 59.088C26.43 60.079 13.466 59.797 0.623993 58.245L0 63.318C13.702 64.967 27.537 65.206 41.289 64.029C41.728 70.581 45.414 96.181 76.56 98.203L76.241 97.347C76.241 97.347 73.938 67.673 50.536 63.029C57.531 62.109 64.473 60.819 71.332 59.162Z",
    fill: "#FED264"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerOrangeLightLeaf);
export default __webpack_public_path__ + "static/media/banner_orange_light_leaf.5735674105aeccc2c5b3e8d03d2f9d2d.svg";
export { ForwardRef as ReactComponent };